import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  getNotificationFilters,
  setBadge,
  markBadgeAsRead,
} from 'src/action-creators/notifications';
import {
  selectShowBadge,
  selectNotificationFilters,
} from 'src/selectors/notifications';
import {NOTIFICATIONS_EVENTS} from 'src/components/notifications/amplitude-events';
import {Panel} from '@spaced-out/ui-design-system/lib/components/Panel';
import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';
import {NotificationPanelContent} from './notification-panel-content';

import css from './notification-panel.css';
import {AnalyticsService} from 'src/analytics';
import {usePageTitle} from 'src/contexts/page-title-context';


export const NotificationPanel = ({
  onClose: onClose = () => {},
  isOpen,
}: {
  onClose: () => void;
  isOpen: boolean;
}) => {
  const {isExtension} = useEnvironmentContext();
  const showBadge = useSelector(selectShowBadge);
  const filters = useSelector(selectNotificationFilters);
  const {
    actions: {setPageTitleProps},
  } = usePageTitle();
  const dispatch = useDispatch();
  const fetchFilters = async () => {
    await dispatch(getNotificationFilters());
  };
  React.useEffect(() => {
    fetchFilters();
    AnalyticsService.track(NOTIFICATIONS_EVENTS.NOTIFICATIONS_BELL_CLICKED, {
      markAsRead: true,
    });
  }, []);

  React.useEffect(() => {
    if (showBadge) {
      dispatch(setBadge(false));
      dispatch(markBadgeAsRead());
    }
  }, [showBadge]);
  React.useEffect(() => {
    if (isExtension) {
      setPageTitleProps({
        hidePageTitle: true,
      });
    }
  }, [setPageTitleProps, isExtension]);

  return isExtension ? (
    <div className={css.panelExt}>
      <NotificationPanelContent onClose={onClose} filters={filters} />
    </div>
  ) : (
    <Panel
      anchor="right"
      initialFocus={1}
      onClose={onClose}
      size="medium"
      tapOutsideToClose
      testId="panel-normal-story"
      isOpen={isOpen}
    >
      <NotificationPanelContent onClose={onClose} filters={filters} />
    </Panel>
  );
};

export default NotificationPanel;
